import React from 'react';

const getAccounting = () => import(/* webpackChunkName: "accounting" */ './accounting');
const getAdmin = () => import(/* webpackChunkName: "admin" */ './admin');
const getBasic = () => import(/* webpackChunkName: "basic" */ './basic');
const getCustom = () => import(/* webpackChunkName: "custom" */ './custom');
const getDeveloper = () => import(/* webpackChunkName: "developer" */ './developer');
const getExpenses = () => import(/* webpackChunkName: "expenses" */ '~/expenses');
const getHome = () => import(/* webpackChunkName: "home" */ '~/home-module');
const getPayroll = () => import(/* webpackChunkName: "payroll" */ '~/payroll-module');
const getMarket = () => import(/* webpackChunkName: "market" */ '~/market');
const getPartnerApi = () => import(/* webpackChunkName: "partner-api" */ './partner-api');
const getProjects = () => import(/* webpackChunkName: "projects" */ './projects');
const getReports = () => import(/* webpackChunkName: "reports" */ './reports');
const getSales = () => import(/* webpackChunkName: "sales" */ './sales');
const getSettings = () => import(/* webpackChunkName: "settings" */ './settings');
const getSystem = () => import(/* webpackChunkName: "system" */ './system');
const getUser = () => import(/* webpackChunkName: "user" */ '~/user');
const getInbox = () => import(/* webpackChunkName: "modules.inbox" */ './modules/inbox');
const getLogout = () => import(/* webpackChunkName: "logout" */ './logout');
const getCharlie = () => import(/* webpackChunkName: "charlie" */ './charlie');

export const sidebars = {
    accounting: React.lazy(() => getAccounting().then(module => ({ default: module.Sidebar }))),
    admin: React.lazy(() => getAdmin().then(module => ({ default: module.Sidebar }))),
    basic: React.lazy(() => getBasic().then(module => ({ default: module.Sidebar }))),
    projects: React.lazy(() => getProjects().then(module => ({ default: module.Sidebar }))),
    reports: React.lazy(() => getReports().then(module => ({ default: module.Sidebar }))),
    sales: React.lazy(() => getSales().then(module => ({ default: module.Sidebar }))),
    settings: React.lazy(() => getSettings().then(module => ({ default: module.Sidebar }))),
    system: React.lazy(() => getSystem().then(module => ({ default: module.Sidebar }))),
    user: React.lazy(() => getUser().then(module => ({ default: module.Sidebar }))),
    expenses: React.lazy(() => getExpenses().then(module => ({ default: module.Sidebar }))),
};

export const content = {
    Accounting: React.lazy(() => getAccounting().then(module => ({ default: module.Content }))),
    Admin: React.lazy(() => getAdmin().then(module => ({ default: module.Content }))),
    Basic: React.lazy(() => getBasic().then(module => ({ default: module.Content }))),
    Custom: React.lazy(() => getCustom().then(module => ({ default: module.Content }))),
    Developer: React.lazy(() => getDeveloper().then(module => ({ default: module.Content }))),
    Expenses: React.lazy(() => getExpenses().then(module => ({ default: module.Content }))),
    Home: React.lazy(() => getHome().then(module => ({ default: module.Content }))),
    Payroll: React.lazy(() => getPayroll().then(module => ({ default: module.Content }))),
    Market: React.lazy(() => getMarket().then(module => ({ default: module.Content }))),
    PartnerApi: React.lazy(() => getPartnerApi().then(module => ({ default: module.Content }))),
    Projects: React.lazy(() => getProjects().then(module => ({ default: module.Content }))),
    Reports: React.lazy(() => getReports().then(module => ({ default: module.Content }))),
    Sales: React.lazy(() => getSales().then(module => ({ default: module.Content }))),
    Settings: React.lazy(() => getSettings().then(module => ({ default: module.Content }))),
    System: React.lazy(() => getSystem().then(module => ({ default: module.Content }))),
    User: React.lazy(() => getUser().then(module => ({ default: module.Content }))),
    Inbox: React.lazy(() => getInbox().then(module => ({ default: module.Content }))),
    Logout: React.lazy(() => getLogout().then(module => ({ default: module.Content }))),
    Charlie: React.lazy(() => getCharlie().then(module => ({ default: module.Content }))),
};
